module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"coach_mark_message":"上にスワイプして <br /> <b>もっと見る</b>","coach_mark_message_pc":"マウスをスクロールするか、キーボードの矢印キー ⬆️⬇️ で<br /><b>さらに多くのレビュー</b>を確認できます。","see_more_reviews":"レビューを見る"}}')
  delete Component.options._Ctor
}
